<template>
    <v-container>
        <v-row class="customTitle" style="padding-bottom: 30px">
            Load Curve
        </v-row>
        <v-row>
            <v-container style="display: flex; justify-items: center">
                <div style="margin: auto" class="homeSection1Image">
                    <img src="../../../assets/images/screenshots/LoadCurveScreenshot.png"
                         alt="React Energy - Interval Data Analysis"
                         style="width: 100%"
                         class="productImage"
                    />
                </div>
            </v-container>
        </v-row>
        <v-row class="customTitle" style="font-size: 2em; padding: 10px 0">
            General
        </v-row>
        <v-row class="customDescriptionText">
            Load curves are one of the most common chart types in energy analysis, displaying the
            variation of load versus time. Load curves give a quick way to see how load compares between different time
            periods. For example, how the load differs from month-to-month.

        </v-row>

        <v-row class="customTitle" style="font-size: 2em; padding: 10px 0">
            Data Types
        </v-row>
        <v-row class="customDescriptionText">
            <ul>
                <li>Kilowatts (kW)</li>
                <li>Kilowatt-hours (kWh)</li>
            </ul>

        </v-row>
        <SummaryLevels/>
        <SeriesType/>
        <Days/>
        <Months/>


    </v-container>
</template>


<script>
    import SummaryLevels from './FilterOptions/SummaryLevels'
    import SeriesType from './FilterOptions/SeriesType'
    import Days from './FilterOptions/Days'
    import Months from './FilterOptions/Months'

    export default {
        components: {
            SummaryLevels,
            SeriesType,
            Days,
            Months
        }
    }
</script>